module.exports = {"id":"158023","name":"Lionel Messi","rating":"94","photo":"./data/images/photos/0/158023.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["ATT","BU","AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LionelMessi0.json
// module id = 2515
// module chunks = 0